import axiosInstance from './axiosInstance';

export interface UserCoinsListParams {
  userId: string;
  currentPage: number;
  pageSize: number;
  coinsOpType: number; // -1:全部积分;1:获得积分;2:消耗积分
}

export interface UserCoinsRecordDTO {
  userId: string;
  coinsSense: number;
  coinsSenseTitle: string;
  coinsSenseDesc: string;
  coinsSenseIconUrl: string;
  source: number;
  coinsOpType: number;
  coins: number;
  bizId: string;
  extData: string;
  createTime: string;
  coinSourceType?: number; // E15: 1=活动 2=会员 3=充值 4=收益
}

export interface UserCoinsListResponseItem {
  total: number;
  currentPage: number;
  pageSize: number;
  records: UserCoinsRecordDTO[];
}

export interface UserCoinsListResponse {
  data: UserCoinsListResponseItem;
}

export interface UserCoinsInfoResponse {
  headImageUrl: string;
  name: string;
  userNumber: number;
  totalCoins: number;
  usageCoins: number;
  remainingCoins: number;
  remainingGivs: number;
  usageGivs: number;
  totalGivs: number;
  memberGoldCoin?: number; // E15: 会员金币余额
  earningGoldCoin?: number; // E15: 收益金币余额
}

export interface UpdateUserCoinsParams {
  coins: number;
  operatorType: 1 | 0; // 1:发放；0:减扣
  userId: string;
}

/**
 * 获取用户硬币明细列表
 */
export const getUsesCoinsList = async (
  params: UserCoinsListParams
): Promise<{
  data: UserCoinsListResponse;
  status: number;
  success: boolean;
  message: string;
}> => {
  const res = await axiosInstance.get<{
    data: UserCoinsListResponse;
    status: number;
    success: boolean;
    message: string;
  }>(`${SUPP_ADMIN_BASE_URL}/supp-management/user/coins/records`, {
    params,
  });
  return res.data;
};

/**
 * 获取用户硬币信息
 */
export const getUserCoinsInfo = async (userId: string) => {
  const res = await axiosInstance.get<{
    status: number;
    success: boolean;
    message: string;
    data: UserCoinsInfoResponse;
  }>(`${SUPP_ADMIN_BASE_URL}/supp-management/review/user/coins/info`, {
    params: { userId },
  });
  return res.data;
};

/**
 * 手动调整用户硬币
 */
export const updateUserCoins = async (params: UpdateUserCoinsParams) => {
  return axiosInstance.post<{ status: number; message: string }>(
    `${SUPP_ADMIN_BASE_URL}/supp-management/review/user/coins/update`,
    params
  );
};
